import React from 'react';
import { RefreshCw } from 'lucide-react';
import './QueryStateView.scss';

/**
 * QueryBackgroundSync Component
 * Displays a subtle, non-intrusive revalidation indicator when background refetching is happening.
 *
 * @param {Object} props
 * @param {boolean} props.isFetching - True when query is fetching in background
 * @param {boolean} [props.isLoading=false] - True when initial load (suppresses badge)
 * @param {string} [props.label='Syncing updates...']
 * @param {'inline'|'floating'|'compact'} [props.variant='inline']
 * @param {string} [props.className='']
 */
export const QueryBackgroundSync = ({
  isFetching,
  isLoading = false,
  label = 'Syncing updates...',
  variant = 'inline',
  className = '',
}) => {
  // Only show when fetching in background (not during initial hard load)
  if (!isFetching || isLoading) return null;

  return (
    <div
      className={`query-bg-sync-badge query-bg-sync-${variant} ${className}`}
      role="status"
      aria-live="polite"
      title="Background revalidation active"
    >
      <span className="query-sync-pulse-dot" />
      <RefreshCw size={12} className="query-sync-icon animate-spin" />
      {variant !== 'compact' && <span className="query-sync-label">{label}</span>}
    </div>
  );
};

export default QueryBackgroundSync;
